import NotFoundPage from './404';

export { NotFoundPage };
